<template>
    <div class='line'  :data-word="scriptObj.value"  >
        <div :class="col1Class()">{{ scriptObj.value }}</div>
        <div class="col col2">{{ scriptObj.note }}</div>
        
        <button v-if="isAdmin()" class="mdl-button mdl-js-button mdl-button--icon btn_editsub btnEdit" @click='clicEditScript()'><i class="material-icons">edit</i></button>
        <button v-if="isAdmin()" class="mdl-button mdl-js-button mdl-button--icon btn_deletesub btnDelete" @click='clicDeleteScript()'><i class="material-icons">delete</i></button>
    </div>  
</template>

<script>
    import axios from 'axios'
    import { diagonalbackURL, defaultConfig } from "../constantes";
    import FctUtils from '@/components/FctUtils';
    import { RoleEnum } from '../classes/enums'

    export default {
        name:"ScriptLine",
        mixins: [FctUtils],
        props:{
            scriptObj: {type:Object},
        },
        data(){
            return {
                settings: {}
            }
        },
        created() {
            // Recuperation des configurations du client
            //
            /*axios(diagonalbackURL + "/clients/"+ this.$store.getters.currentClientId+"/settings",  defaultConfig)
            .then(reponse => {
                this.settings = reponse.data;
            })
            .catch(error => this.errorHandler(error));*/
        },
        methods : {
            isAdmin(){
                // Les 2 boutons sont desactivé pour l'instant
                return false && (this.$store.state.currentUser.role == RoleEnum.ADMIN.value ||  this.$store.state.currentUser.role == RoleEnum.SUPERADMIN.value);
            },
            col1Class() {
                var result = 'col col1 ';
                result +=  (this.scriptObj.active)? 'green' : 'red'
                return result;
            },
            clicDeleteScript() {
                this.emitter.emit('showPLForm', {mode:'formScript_remove', data:this.scriptObj});
            },
            clicEditScript() {
                this.emitter.emit('showPLForm', {mode:'formScript_edit', data:this.scriptObj});
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.pl-list .line {
    position:relative;
    width : 100%;
}

.btnEdit {
    position: absolute;
    top: 5px;
    right: 25px;
    color: #0075bb;
}

.btnDelete {
    position: absolute;
    top: 5px;
    right: 5px;
}
</style>
